
    import './block/post-grid/view.js';
    import './block/advance-slider/view.js';    
    import './block/image/view.js';    
    import './block/video/view.js';  
    import './block/faq/view.js';    
    import './block/table-of-contents/view.js';    
    import './block/pin/view.js';    
    import './block/image-hotspot/view.js'; 
    import './block/advance-query-loop/view.js'; 
    import './block/timeline-child/view.js'; 
    import './block/unfold/view.js'; 
    import './block/advance-timeline/view.js'; 
    import './block/post-pagination/view.js'; 
    import './block/swipe-slider/view.js'; 
    import './block/lottie/view.js'; 
    import './block/animation/frontend.js'; 
    import './block/animation/frontend/count/index.js'; 
    import './block/animation/frontend/typing/index.js'; 

